import { createContext, useContext } from "react";

export const SequenceDetailContext = createContext(null);

export function useSequenceDetail() {
  const ctx = useContext(SequenceDetailContext);
  if (!ctx) {
    throw new Error("useSequenceDetail must be used within SequenceDetail");
  }
  return ctx;
}
